import React from "react";

const Footer = ({ lastUpdated = "24/07/2025" }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center text-xs sm:text-sm text-white/80 space-y-2 py-6 bg-marino">
      <p>
        © {currentYear} Cardiología del Norte S.A. de C.V. Todos los derechos reservados.
      </p>

      <p className="leading-snug">
        Registro publicidad COFEPRIS 243300201A2496 <br />
        Responsable sanitario Dr Ramón Horacio Limón Rodríguez, UNAM, cédula de especialidad 3507513
      </p>

      <nav
        className="flex flex-wrap justify-center gap-4"
        aria-label="Enlaces legales y de privacidad"
      >
        <a href="/aviso_de_privacidad.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline">
          Aviso de Privacidad (PDF)
        </a>
        <a href="/simplificado.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline">
          Aviso Simplificado
        </a>
        <a href="/cookies.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline">
          Política de Cookies
        </a>
        <a href="/terminos_uso.pdf" target="_blank" rel="noopener noreferrer" className="hover:underline">
          Términos de Uso
        </a>
        <a
          href="mailto:cardiologianorte221@outlook.com"
          className="hover:underline"
          aria-label="Contacto ARCO (cardiologianorte221@outlook.com)"
        >
          Contacto ARCO
        </a>
      </nav>

      <p className="text-white/60">Última actualización: {lastUpdated}</p>
    </footer>
  );
};

export default Footer;